// PHASE 3: Validation feedback on design blocks
import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function DesignBlocksFeedbackPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <FeedbackPage
      emoji="🎯"
      heading={t('pages.onboarding.v2.designBlocksFeedback.heading')}
      text={t('pages.onboarding.v2.designBlocksFeedback.description')}
      onSubmit={handleSubmit}
    />
  )
}
